import React from 'react';

export default function TableRow(props) {
    const getCellClassName = (child) => {
        if (!child || !child.hasOwnProperty('props')) {
            return '';
        }
        if (!child.props.hasOwnProperty('cellClassName')) {
            return '';
        }
        return child.props.cellClassName;
    }

    return (
        <tr key={`row-${props.rowId}`} className="visit-row" id={`row-${props.rowId}`}>
            {Object
                .keys(props.children)
                .map(key =>
                    <td key={key}
                        className={getCellClassName(props.children[key])}
                    >
                        {props.children[key]}
                    </td>

                )
            }
        </tr>
    )
}
